import { z } from 'zod';

/** One turn in the Ask-AI conversation. v1 is stateless — the client sends the
 * running history with every request (no server-side persistence). */
export const aiChatMessageSchema = z.object({
  role: z.enum(['user', 'assistant']),
  content: z.string().min(1).max(8000),
});
export type AiChatMessageInput = z.infer<typeof aiChatMessageSchema>;

export const aiChatInputSchema = z.object({
  /** Full conversation so far, oldest first, ending with the new user turn. */
  messages: z.array(aiChatMessageSchema).min(1).max(40),
});
export type AiChatInput = z.infer<typeof aiChatInputSchema>;

export interface AiChatResponse {
  /** The assistant's answer text. */
  reply: string;
  /** Names of the read-only tools the assistant invoked to answer (for transparency). */
  toolsUsed: string[];
}
